/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="20.88" height="20.57" viewBox="0 0 20.88 20.57" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <path fill="none" stroke="#1570bc" d="M5.76 3.62h-3.6a1.39 1.39 0 0 0-1.4 1.5v13.2a1.54 1.54 0 0 0 1.5 1.5h13.2a1.54 1.54 0 0 0 1.5-1.5v-3" className="icon-stroke" strokeWidth="1.5"/>
        <path fill="none" stroke="#1570bc" d="M19.73 1.09 8.55 12.26" className="icon-stroke" strokeWidth="1.75" strokeLinecap="round"/>
        <path fill="none" stroke="#1570bc" d="m11.03.88 8.77.14.21 8.84" className="icon-stroke" strokeWidth="1.75" strokeLinejoin="round" strokeLinecap="round"/>
      </svg>
    );
  }
}

Icon.displayName = 'BoxWithArrowPointingOutwardIcon';

export default Icon;
